import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { supabase } from '@/lib/supabase';
import { Toast } from '@/components/common/Toast';

// Desktop components following SRP
import { FindIdForm } from '@/components/desktop/auth/FindIdForm';
import { FindIdResult } from '@/components/desktop/auth/FindIdResult';

export function DesktopFindIdPage() {
  const navigate = useNavigate();
  
  // 모바일 로직 재사용 - 상태 관리
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [foundEmail, setFoundEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState<{ show: boolean; message: string }>({ show: false, message: '' });

  // 모바일 로직 재사용 - 아이디 찾기 핸들러
  const handleFindId = async () => {
    if (!name || !phone) {
      setToast({ show: true, message: '이름과 전화번호를 모두 입력해주세요' });
      return;
    }

    setIsLoading(true);
    try {
      // 전화번호와 이름으로 사용자 찾기
      const { data, error } = await supabase
        .from('users')
        .select('email')
        .eq('phone', phone)
        .eq('name', name)
        .single();

      if (error || !data) {
        setToast({ show: true, message: '일치하는 사용자 정보를 찾을 수 없습니다' });
        setFoundEmail('');
      } else {
        // 이메일 마스킹 처리
        const email = data.email;
        const [localPart, domain] = email.split('@');
        const maskedLocal = localPart.length > 3 
          ? localPart.substring(0, 3) + '*'.repeat(localPart.length - 3)
          : '*'.repeat(localPart.length);
        const maskedEmail = `${maskedLocal}@${domain}`;
        
        setFoundEmail(maskedEmail);
        setToast({ show: true, message: '아이디를 찾았습니다!' });
      }
    } catch (error) {
      setToast({ show: true, message: '아이디 찾기 중 오류가 발생했습니다' });
      setFoundEmail('');
    } finally {
      setIsLoading(false);
    }
  };

  // 모바일 로직 재사용 - 로그인 페이지 이동
  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <DesktopLayout>
      <div className="min-h-[80vh] flex items-center justify-center py-12">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg border border-gray-200 px-10 py-12">
          
          {/* 헤더 */}
          <div className="text-center mb-10">
            <h1 className="text-[28px] font-bold text-[#222222] mb-4">아이디 찾기</h1>
          </div>

          {!foundEmail ? (
            // Form Section - SRP: 입력 폼만 담당
            <FindIdForm
              name={name}
              phone={phone}
              isLoading={isLoading}
              onNameChange={setName}
              onPhoneChange={setPhone}
              onSubmit={handleFindId}
            />
          ) : (
            // Result Section - SRP: 결과 표시만 담당
            <FindIdResult
              foundEmail={foundEmail}
              onGoToLogin={handleGoToLogin}
            />
          )}
        </div>
      </div>

      {/* 토스트 메시지 */}
      {toast.show && (
        <Toast
          message={toast.message}
          isVisible={toast.show}
          onClose={() => setToast({ show: false, message: '' })}
        />
      )}
    </DesktopLayout>
  );
}